import type { ButtonProps } from '@mui/material';
import { createContext } from 'react';

interface ConfirmDialogActionData extends ButtonProps {
  label: string;
}

export interface ConfirmDialogData {
  title: string;
  description: string;
  actions: ConfirmDialogActionData[];
  maxWidth?: number;
}

export interface ConfirmContextProps {
  alert(data: ConfirmDialogData): void;
}

export const ConfirmContext = createContext<ConfirmContextProps>({
  alert: () => null,
});
